import Xylophone from "xylophone-react";
import GithubCorner from "react-github-corner";

import "./App.css";

export default function App() {
  return (
    <div className="Page">
      <GithubCorner
        href="https://github.com/LauraAubin/Xylophone-react"
        bannerColor="#81668c"
        octoColor="#F4F6F8" // (sky, light)
        size={100}
      />

      <div className="XyloWrapper">
        <Xylophone />
      </div>
    </div>
  );
}
